import React, { FC } from 'react'
import {
  IHistoryTableData,
  IHistoryTableRow,
  IRecapHistoryRafQty,
} from '../../../../interfaces/IHistory'
import { TYPE_SUMMARY, VIEW_TYPE } from '../../../../constants/tables'
import { useHistoryTotal } from '../../../../hooks/history/useHistoryTotal'
import { HISTORY_TRIMESTER_INITIAL_STATE_TOTAL } from '../../../../__mocks__/historyMock'
import { isEmptyObj } from '../../../../utils/helpers'
import { TrimesterTableRow } from './TrimesterTableRow'

export const TrimesterTableContent: FC<IHistoryTableData> = ({
  data,
  clientId,
}) => {
  const { summaryTotal, rafQty, totalRafQty } = useHistoryTotal(
    data,
    clientId,
    VIEW_TYPE.TRIMESTER,
    HISTORY_TRIMESTER_INITIAL_STATE_TOTAL
  )

  return (
    <>
      {!!data?.length && !isEmptyObj(summaryTotal) && (
        <TrimesterTableRow
          currentYear={summaryTotal.currentYear}
          previousYear={summaryTotal.previousYear}
          customClass="fontBold backgroundSecondaryLight"
          rafQty={totalRafQty}
        />
      )}
      {!!data?.length &&
        data.map(
          (
            { type, name, currentYear, previousYear }: IHistoryTableRow,
            index: number
          ) => (
            <TrimesterTableRow
              key={index.toString()}
              currentYear={currentYear}
              previousYear={previousYear}
              name={name}
              customClass={`${
                type === TYPE_SUMMARY && 'fontBold backgroundNeutralLight'
              }`}
              rafQty={rafQty ? (rafQty[index] as IRecapHistoryRafQty)?.qty : 0}
            />
          )
        )}
    </>
  )
}
